<script setup lang="ts">
const { t } = useI18n();
const localePath = useLocalePath();

const currentStep = defineModel("currentStep", { type: Number, required: true });

const steps = ref<string[]>([
  t('page.create_business.nav.business_type'),
  t('page.create_business.nav.business_details'),
  t('page.create_business.nav.business_owner'),
  t('page.create_business.nav.finish')
]);
</script>

<template>
  <div class="bg-none lg:bg-[url('/dashes-bottom.svg')] bg-no-repeat bg-contain bg-center-bottom w-full lg:w-100 lg:h-full h-52.5 flex flex-col lg:items-start items-center space-y-10 lg:-right-1/2 bg-default-500 p-8 lg:p-15 overflow-y-auto">
    <div class="flex justify-start items-center h-15">
      <ULink :to="localePath('/')">
        <img src="/l-h-logo.svg" alt="bookforme logo" >
      </ULink>
    </div>
    <div class="flex-1 flex flex-raw lg:flex-col space-x-8 rtl:space-x-reverse lg:space-x-0 lg:space-y-8 text-white">
      <div v-for="(step, index) in steps" :key="index" class="flex items-center space-x-5 rtl:space-x-reverse">
        <div class="relative flex lg:block">
          <div
              :class="[
                'flex justify-center items-center border rounded-full w-12 h-12',
                currentStep === index + 1 ? 'border-heart-purple' : (currentStep > index + 1 ? 'bg-heart-purple border-heart-purple' : 'border-gentian-navy'),
              ]"
          >
            {{ index + 1 }}
          </div>
          <div
v-if="index !== 3"
               class="absolute my-[50%] mx-[100%] lg:my-auto lg:mx-[50%] w-8 lg:w-0.5 h-0.5 lg:h-8"
               :class="[currentStep === index + 1 ? 'bg-gentian-navy' : (currentStep > index + 1 ? 'bg-heart-purple' : 'bg-gentian-navy')]"
          />
        </div>
        <span class="hidden lg:block">{{ step }}</span>
      </div>
    </div>
  </div>
</template>
